<template>
  <el-dialog
    title="意见反馈"
    :visible.sync="dialogFormVisible"
    width="1280px"
    @close="closedata"
  >
    <el-form ref="form" :model="form" :rules="rules">
      <el-form-item label="所属应用：" :label-width="formLabelWidth">
        {{ $store.state.user.userDetal.agentName }}
      </el-form-item>
      <el-form-item
        label="问题和意见："
        prop="advice"
        :label-width="formLabelWidth"
      >
        <el-input
          resize="both"
          type="textarea"
          maxlength="300"
          placeholder="请输入问题和意见"
          v-model="form.advice"
          show-word-limit
        >
        </el-input>
      </el-form-item>
      <el-form-item label="上传图片：" :label-width="formLabelWidth">
        <div>
          <p
            style="font-size: 13px;
              font-weight: 400;
              color: #999999;
              line-height: 30px;"
          >
            限制大小20M
          </p>
          <el-upload
            class="avatar-uploader avatar-uploader-shenfenzheng"
            :class="{ hide: fileList.length === 5 }"
            :action="upLoadApi"
            :on-progress="onProgress"
            :on-change="handleRemove"
            :on-success="onSuccess"
            :on-error="onError"
            style="margin-top: 15px;"
            :headers="headers"
            list-type="picture-card"
            :limit="limit"
            :before-upload="beforeAvatarUpload"
            :file-list="fileList"
          >
            <i
              slot="default"
              class="el-icon-plus avatar-uploader-icon"
              style="font-size: 40px;margin-top: 16px"
              ><p style="font-size: 13px;margin-top: 16px;color: #999999;">
                上传图片
              </p></i
            >

            <div slot="file" slot-scope="{ file }">
              <img class="avatar" :src="file.url" alt="" />
              <div class="boxx" @click.stop="onFileDelete(file)">
                <img
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAB9klEQVQ4T3WST6hSQRTGv5muxcWFoiAlgs9WEYKvRdHORbsEEZQgbRUYbotAuSLchfe68a0jKALbujBzEYIIbso/UCLI24mS4k6DcnN1TtwLivh4s5qZc37nfN/MYThauq7fJ6LXAJ4A8BLRH875D875h1wu9/U4l+0PxWIxxxgrArhxnHC0/2IYxgtVVf+adxao6/obIrq4BoAkSdjtdhBCfNtutxFVVQUrlUpnQohLzvmtTCaDWq2GxWJxqOFwOJBKpdBoNDCbzcAYe6koyiem63qJiHJmZiAQQDQaRbVaxXw+h9PptKB+v49er7cv9iufzz9gmqZ9B/B4f+v3+xGLxdBqtRAOh9HtdjEYDA4KGGMky7LLBCcAzo79hUIhRCIRC2g2m1esS5J0zwR/AjjfR10ulyVvPB4jGAxanqfT6Sl82wTfAciYEbfbjWQyiU6ng+FwCJ/Ph3g8jnq9jsnEFGatST6fv2u+6kMhRFeWZZZOp9FutzEajQ4dvF4vEokEKpUK1uu1+aoFRVGK1j9qmvaec/7K4/FguVxe8WS327HZbEBE49Vq9ahcLv+zQFVVb9psts8Anl03BAAuhRBPC4WCpfkwcuZe07TnRPSWc35ORFaMMfabiD4ahlHej9speGim67qbiO5IkrTOZrNzAHSq5D8ce800Td7rRQAAAABJRU5ErkJggg=="
                  alt=""
                />
              </div>
            </div>
          </el-upload>
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="mini" type="default-mini" @click="closedata"
        >取 消</el-button
      >
      <el-button size="mini" type="primary-font-mini" @click="upinsertAppAdvice"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
const baseURL = process.env.VUE_APP_BASEP_URL;
import Cookies from "js-cookie";
import { insertAppAdvice } from "@/config/api/login";
import { showLoading } from "@/basa/utils/public";
export default {
  name: "feedback",
  data() {
    return {
      headers: {
        Authorization: Cookies.get("access_token") || ""
      },
      advice: "",
      imageUrl: "",
      advicePictureId: "",
      advicePicture: "",
      uploadLoading: null,
      limit: 5,
      fileList: [],
      formLabelWidth: "90px",
      upLoadApi: this.$addUrlPerFix(baseURL) + "/apis/basap/uploadLogo",
      dialogFormVisible: false,
      isShow: false,
      form: {
        url: "",
        description: "",
        advice: ""
      },
      rules: {
        advice: {
          required: true,
          message: "请输入问题和意见", //请选择填报单位
          trigger: "blur"
        }
      }
    };
  },
  methods: {
    onFileDelete(file) {
      console.log(file);
      console.log("fileList:", this.fileList);
      this.fileList = this.fileList.filter(item => item.uid !== file.uid);
    },
    closedata() {
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
      this.dialogFormVisible = false;
      this.form.advice = "";
      this.fileList = [];
      this.resetSetItem("languageChangeHandler1", false);
    },
    // 上传时附件信息
    onProgress(progressEvent) {
      if (progressEvent.percent > 90) {
        progressEvent.percent = 98;
      }
    },
    onSuccess() {
      this.uploadLoading.close();
    },
    onError({ message }) {
      this.$message({
        message: message,
        type: "error",
        duration: 3000,
        ccuiCustom: true,
        showClose: true,
        offset: document.body.clientHeight / 2 - 21
      });
      this.uploadLoading.close();
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 20;
      if (!isJPG) {
        this.$message({
          message: "上传图片只能是 JPG 格式或PNG格式!",
          type: "error",
          duration: 3000,
          ccuiCustom: true,
          showClose: true,
          offset: document.body.clientHeight / 2 - 21
        });
        return false;
      }
      if (!isLt2M) {
        this.$message({
          message: "上传图片大小不能超过 20MB!",
          type: "error",
          duration: 3000,
          ccuiCustom: true,
          showClose: true,
          offset: document.body.clientHeight / 2 - 21
        });
        return false;
      }
      // 上传中
      this.uploadLoading = showLoading("上传中...");
      return isJPG && isLt2M;
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.fileList = fileList;
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    upinsertAppAdvice() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          let advicePictureId = [];
          let advicePicture = [];
          this.fileList.map(item => {
            advicePicture.push(item.response.data[0].downloadUrl);
            advicePictureId.push(item.response.data[0].uploadId);
          });
          insertAppAdvice({
            appName: this.$store.state.user.userDetal.agentName,
            advice: this.form.advice,
            advicePictureIdReq: advicePictureId,
            advicePictureReq: advicePicture,
            isShowLoading: true
          }).then(res => {
            console.log(res);
            if (res.data.code == "0") {
              this.$message({
                message: "提交成功",
                type: "success",
                duration: 2000,
                ccuiCustom: true,
                showClose: true,
                offset: document.body.clientHeight / 2 - 21
              });
              this.dialogFormVisible = false;
              this.form.advice = "";
              this.fileList = [];
              this.resetSetItem("languageChangeHandler1", false);
            }
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .el-textarea__inner {
  // width: 900px;
  height: 200px;
}
/deep/ .el-dialog__body {
  padding: 10px 40px;
  height: 455px;
}
/deep/ .avatar-uploader .el-upload {
  width: 100px;
  height: 100px !important;
  line-height: 100px;
  background: #fff !important;
  border-radius: 0px !important;
  border: 1px dashed #d1d1d1;
  cursor: pointer;
  position: relative;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.boxx {
  width: 14px;
  height: 14px;
  position: absolute;
  right: -10px;
  top: -10px;
}
.avatar-uploader-icon {
  color: #d8d8d8;
  text-align: center;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
/deep/ .el-upload-list__item {
  width: 100px !important;
  height: 100px !important;
  margin: 0 20px 8px 0;
  overflow: inherit !important;
}

/deep/ .hide .el-upload--picture-card {
  display: none;
}

/deep/ .el-form-item__content {
  margin-left: 90px;
}
</style>
